import { jsx as _jsx } from "react/jsx-runtime";
export const SuccessIcon = () => {
    return (_jsx("svg", Object.assign({ width: "22", height: "17", viewBox: "0 0 22 17", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M7 13.4478L1.75 8.1194L0 9.89552L7 17L22 1.77612L20.25 0L7 13.4478Z", fill: "black" }, void 0) }), void 0));
};
//# sourceMappingURL=SuccessIcon.js.map